import React from 'react';
import { reduxForm, Field  } from 'redux-form';
import CheckboxField from './../../../shared/form-elements/checkbox';

const Form = props => {

	return (
		<form className="display-flex">
			<div className="padding-10-15">
				<Field
					name="can_copy_offer_id"
					normalize={Boolean}
					placeholder="Сopy offer ID "
					component={CheckboxField}
				/>
			</div>
			<div className="padding-10-15">
				<Field
					name="can_copy_category"
					normalize={Boolean}
					placeholder="Сopy nishe"
					component={CheckboxField}
				/>
			</div>
			<div className="padding-10-15">
				<Field
					name="are_new_offers_included"
					normalize={Boolean}
					placeholder="New offers"
					onChange={props.toggleIsIncludedNewOffers}
					component={CheckboxField}
				/>
			</div>
		</form>
	);
};

export default reduxForm({ form: 'topOffersCheckbox' })(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-offers/components/form/main.js